import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { api } from '../../services/api';
import { DeleteAccountContext } from '.';
import environmentConfig from '../../config/environment-configs';
import { Loading } from '../../components/Loading';

const DeleteConfirm = () => {
  const { setStep, setUserDeleteReasons } = useContext(DeleteAccountContext);
  const { reasonId } = useParams<{ reasonId: string }>();

  const getRecaptchaToken = async (): Promise<string> => {
    return new Promise(resolve => {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(environmentConfig.GOOGLE_RECAPTCHA_KEY, {
            action: 'exclusaoDeContaConfirmarSenhaMinhaConta',
          })
          .then((token: string) => {
            resolve(token);
          });
      });
    });
  };

  const logoutOnAPI = async (token: string, callback: () => void) => {
    if (!token || token === '') {
      return;
    }
    await api
      .delete('/auth', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        localStorage.removeItem('token_jwt');
      })
      .catch(() => {
        toast.error('Falha na requisição de Logout!');
      });
    callback();
  };

  const removeAuthWithoutRedirect = () => {
    const token = localStorage.getItem('token_jwt') || '';
    logoutOnAPI(token, () => {
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = `${environmentConfig.LOGOUT_URL}/&client_id=${environmentConfig.OIDC_CLIENT_ID}`;
      document.body.appendChild(iframe);
    });
  };

  const handleSubmit = async (userReasons: string[]) => {
    const token = localStorage.getItem('token_jwt');
    const userToUpdate = {
      answers: userReasons,
    };

    const recaptchaToken = await getRecaptchaToken();

    api
      .put('/account/quarantine', userToUpdate, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Recaptcha-Token': recaptchaToken,
        },
      })
      .then(response => {
        if (response.status === 200) {
          removeAuthWithoutRedirect();
          setStep('success');
        }
      })
      .catch(reason => {
        if (reason.response.status === 401) {
          toast.error('Não foi possível confirmar sua senha. Tente novamente.');
        } else {
          toast.error('Não foi possível excluir sua conta.');
        }
        setStep('error');
      })
      .finally(() => {
        sessionStorage.removeItem(`${reasonId}`);
      });
  };

  useEffect(() => {
    if (reasonId) {
      const userReasons = sessionStorage.getItem(`${reasonId}`)?.split('|');
      if (userReasons) {
        setUserDeleteReasons(userReasons);
        handleSubmit(userReasons);
      } else {
        setStep('subscriptions');
      }
    } else {
      setStep('error');
    }
  }, [reasonId]);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="colored"
      />
      <Loading />
    </>
  );
};

export default DeleteConfirm;
